module.exports = __webpack_public_path__ + "img/video_icon06.4e0bf76a.png";